import { createRootRoute, Outlet } from '@tanstack/react-router'
import { Button } from '@/components/ui/controls'
import { EmptyState } from '@/components/ui/feedback'

export const Route = createRootRoute({
  component: () => <Outlet />,
  notFoundComponent: () => (
    <div className="grid min-h-dvh place-items-center bg-app">
      <EmptyState
        title="Page not found"
        description="That URL does not exist."
        action={
          <a href="/matches">
            <Button variant="primary">Back to matches</Button>
          </a>
        }
      />
    </div>
  ),
  errorComponent: ({ error }) => (
    <div className="grid min-h-dvh place-items-center bg-app">
      <EmptyState
        title="Something went wrong"
        description={error.message}
        action={<Button onClick={() => window.location.reload()}>Reload</Button>}
      />
    </div>
  ),
})
